export const maxNicknameLength = 18;